module.exports = __webpack_public_path__ + "Public/Home/staticmokao/img/part7.0173e19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/part7.jpg
// module id = 58aV
// module chunks = 1